import React from 'react';
import ExternalLink from '~/components/ExternalLink';
import { FormGroup, Input, Label, FormFeedback } from 'reactstrap';
import ErrorList from '../ErrorList';
import { getAppContext } from '~/lib/AppContext';

type AgreeTermsProps = {
    checked: boolean;
    errors?: string[];
    onChange: (checked: boolean) => unknown;
    disabled?: boolean;
};

export default class AgreeTerms extends React.Component<AgreeTermsProps> {
    render() {
        const { checked, errors, onChange, disabled } = this.props;
        return (
            <FormGroup check>
                <Input
                    id="agreeTermsCheck"
                    type="checkbox"
                    checked={checked}
                    onChange={(e) => onChange(e.target.checked)}
                    invalid={errors && errors.length > 0}
                    disabled={disabled}
                />
                <Label check for="agreeTermsCheck">
                    I agree to the{' '}
                    <ExternalLink href={getAppContext().config.wwwSite + '/terms-of-service'}>
                        Terms of Service
                    </ExternalLink>{' '}
                    and{' '}
                    <ExternalLink href={getAppContext().config.wwwSite + '/refund-policy'}>refund policy.</ExternalLink>
                </Label>
                <FormFeedback>
                    <ErrorList errors={errors} />
                </FormFeedback>
            </FormGroup>
        );
    }
}
